export const removeGlobalCSSVariable = (variable: string) => {
  document.documentElement.style.removeProperty(variable);
};
